/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMoneyInSddInput
 */
export interface GetMoneyInSddInput {
    /**
     * Unique ID Generated by your Server
     * @type {string}
     * @memberof GetMoneyInSddInput
     */
    reference?: string;
    /**
     * UTC Unix Timestamp
     * @type {string}
     * @memberof GetMoneyInSddInput
     */
    updateDate?: string;
    /**
     * End Date UTC Unix Timestamp
     * @type {string}
     * @memberof GetMoneyInSddInput
     */
    updateEndDate?: string;
}

/**
 * Check if a given object implements the GetMoneyInSddInput interface.
 */
export function instanceOfGetMoneyInSddInput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetMoneyInSddInputFromJSON(json: any): GetMoneyInSddInput {
    return GetMoneyInSddInputFromJSONTyped(json, false);
}

export function GetMoneyInSddInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMoneyInSddInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
        'updateDate': !exists(json, 'updateDate') ? undefined : json['updateDate'],
        'updateEndDate': !exists(json, 'UpdateEndDate') ? undefined : json['UpdateEndDate'],
    };
}

export function GetMoneyInSddInputToJSON(value?: GetMoneyInSddInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reference': value.reference,
        'updateDate': value.updateDate,
        'UpdateEndDate': value.updateEndDate,
    };
}

